<template>
  <WidgetBaseCard v-bind="$props" v-on="$listeners">
    <template #title>
      <slot name="title"></slot>
    </template>

    <template #content>
      <v-spacer></v-spacer>

      <slot name="graph"></slot>
    </template>
  </WidgetBaseCard>
</template>
<script>
import WidgetBaseCard from "./WidgetBaseCard.vue";
export default {
  components: { WidgetBaseCard },

  props: {
    error: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    hideTableBtn: {
      type: Boolean,
      default: false
    },
    lastUpdate: {
      type: Date,
      default: null
    }
  }
};
</script>
